export const GETTING_STARTED = {
  FIND_MORE_WORKERS: "find more workers",
  POST_MORE_SHIFTS: "post more shifts",
  BOOK_QUALIFIED_WORKER: "book qualified worker",
  CAROUSEL_PREVIOUS_SLIDE: "carousel previous slide",
  CAROUSEL_NEXT_SLIDE: "carousel next slide",
  DOWNLOAD_MOBILE_APP: "download mobile app",
  ADD_TEAM_MEMBER: "add team member",
  ADD_CHECK_IN_INSTRUCTIONS: "add check-in instructions",
  TAKE_PRODUCT_TOUR: "take product tour",
  TEAM_ADDITION_INFO_POPOVER_CLOSED: "team addition info popover closed",
} as const;

export const ADMIN_DISABLED_TOOLTIP = "This action is not available for admin users";

import { type TaskStepKey } from "./types";

interface TaskCardConfig {
  key: TaskStepKey;
  headingComplete: string;
  headingIncomplete: string;
  descriptionComplete: string;
  descriptionIncomplete: string;
}

export const TASK_CARDS: readonly TaskCardConfig[] = [
  {
    key: "getMobileApp",
    headingComplete: "Mobile app downloaded",
    headingIncomplete: "Download the mobile app",
    descriptionComplete: "Use the mobile app to manage your schedule from anywhere.",
    descriptionIncomplete: "Get the app so you can manage your schedule from anywhere.",
  },
  {
    key: "addTeamMembers",
    headingComplete: "Team members added",
    headingIncomplete: "Add team members",
    descriptionComplete:
      "Click to update your or your team's user information and notification preferences.",
    descriptionIncomplete: "Invite teammates to the platform and control their level of access.",
  },
  {
    key: "checkInstructions",
    headingComplete: "Check-in info added",
    headingIncomplete: "Add check-in information",
    descriptionComplete: "Use this page to keep your professional-facing instructions up-to-date.",
    descriptionIncomplete:
      "Share relevant information with workers on how to complete a successful first shift.",
  },
  {
    key: "takeProductTour",
    headingComplete: "Need Help?",
    headingIncomplete: "Need Help?",
    descriptionComplete: "Head to our Self-Help Center to get answers to your questions.",
    descriptionIncomplete: "Head to our Self-Help Center to get answers to your questions.",
  },
];

export const INTERMEDIATE_SHIFT_POSTING_OPTIONS = {
  CLOSE: "close",
  POST_BLOCK_SHIFTS: "post block-shifts",
  POST_PER_DIEM_SHIFT: "post per-diem shift",
} as const;
